import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, catchError, EMPTY, finalize, first, switchMap, tap } from 'rxjs';
import { Constants } from 'src/app/core/constants';
import { SalesOrderDetails } from 'src/app/core/models/sales/sales-order-details.interface';
import { OrganizationService } from 'src/app/core/services/organization.service';

@Component({
  selector: 'app-organization-sales-order-overview',
  templateUrl: './organization-sales-order-overview.component.html',
  styleUrl: './organization-sales-order-overview.component.scss',
  standalone: false,
})
export class OrganizationSalesOrderOverviewComponent {
  private readonly organizationService = inject(OrganizationService);

  public readonly notFound = Constants.NotFound;
  public isLoading = false;
  public companyId = '';
  public organizationId = '';
  public salesOrderId = '';

  public readonly salesOrder$ = new BehaviorSubject<SalesOrderDetails | null>(null);

  constructor() {
    const route = inject(ActivatedRoute);

    route.params
      .pipe(
        first(),
        tap(() => (this.isLoading = true)),
        tap((params) => {
          this.salesOrderId = params['salesOrderId'];
          this.organizationId = params['organizationId'];
          this.companyId = route.parent?.parent?.snapshot.params['id'];

          this.organizationService.setOrganizationsUrl(this.companyId);
        }),
        switchMap(() =>
          this.organizationService.getOrganizationSalesOrder(
            this.organizationId,
            this.salesOrderId,
          ),
        ),
        tap((salesOrder) => this.salesOrder$.next(salesOrder)),
        catchError(() => {
          this.salesOrder$.next(null);
          return EMPTY;
        }),
        finalize(() => (this.isLoading = false)),
      )
      .subscribe();
  }
}
